<template>
  <div class="btnitem" @click="signUp">
    <img style="width:20px;height:20px" src="@/assets/linshiyonggong/baoming@2x.png"/>
    <span>立即报名</span>
  </div>
</template>

<script>
import {checkDataStatus} from "@/utils/checkDataStatus"

export default {
  name: "signUp",
  props:{
    item:{
      type:Object,
      default(){
        return {}
      }
    },
    type: {
      type: [Number,String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    }
  },
  methods:{
    /** @name 立即报名 */
    async signUp() {
      if(this.permissionTips({
        type:['person']
      })) return

      const dataState = await checkDataStatus(this.type,this.item.no)
      if(!dataState){
        this.$message.error('系统异常，请稍后再试')
        return
      }
      if(dataState!=1){
        this.$emit('changeStatus',dataState)
        return
      }


      let user=this.$store.state.user;

      let state='';
      if(user.type==0){
        state=user.no==this.item.userNo?"操作失败，不能对自己发布的内容进行该操作":''
      }else if(user.type==1){
        state=user.companyNo==this.item.companyNo?"操作失败，不能对同企业发布的内容进行该操作":''
      }else if(user.type==2){
        state=user.teamNo==this.item.teamNo?"操作失败，不能对同团队发布的内容进行该操作":''
      }
      if(this.item.isApply){
        state="请勿重复报名"
      }
      if(state){
        this.$message.error(state)
        return;
      }
      this.$router.push({
        path: "/signUp",
        query: {
          no: this.item.no,
          categoryNo: this.item.categoryNo,
          industryNo: this.item.industryNo,
          categoryName: this.item.categoryName,
          industryName: this.item.industryName,
          createUser: this.item.createUser
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.btnitem {
  width:auto !important;
  padding: 7px 15px;
}
</style>
